//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            how_search_loading: false,
            selected: '',
        }
    },
    watch: {
        selectedItem (latest, old) {
            if (latest !== old) {
                this.selected = latest
            }
        }
    },
    methods: {
        changeSelected(type) {
            this.selected = type
            this.$emit('changeSelected', type)
        },
        openLocation(e) {
            this.tabLog(e)
            this.$emit('openLocation')
        },
        tabLog(e) {
            const { log } = e.currentTarget.dataset
            if (log) {
                this.$sendCtmEvtLog(`${log}`)
            }
        },
    },
    props: {
        keyword: String,
        "share-type": {
            type: String,
            default: "black",
            validator (value) {
                const themes = ["black", "white", "primary"]
                return value && themes.includes(value)
            }
        },
        "show-selects": Boolean,
        "show-loading": Boolean,
        "selects-options": Array,
        "selected-item": String,
        "show-search": Boolean,
        "show-location": Boolean,
        "show-share": Boolean,
        "theme": String,
        "share-log": String,
        "location-log": String,
    }
}
